
import { Location } from '@angular/common';
import { Component, Input, Output, OnInit, OnDestroy, ViewChild, AfterViewInit, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

// shared libs
import { ToastService, StepperComponent, ModalService } from '../../blocks';
import { ControlsParams, AppCodeGroup, FormSettingsService, SharedDateService, FormGroupCreationService, UserSessionService, getNgBsObj, getDateObj, IDefaults } from '../../shared';
import { NgbModal } from '../../ng-bootstrap/index';
import { NameComponent } from '../../blocks/names/name.component';
import { NameService } from '../../blocks/names/name.service';
import { AddressComponent } from '../../hospitalSetup/address/address.component';
import { IdentityTypeComponent, IIdentity } from '../../blocks/identity_type/identity_type.component';
import { PatientCancelService } from '../PatientCancel/patCancel.service';
// services
import { Patient, PatientVM, PatCancel, PatientData, IPatientEmergency } from './patient';
import { PatientService } from './patient.service';
import { FamilyDetail } from '../family-details/family-detail.service';
import { MaritalStatus } from '../../hospitalSetup/marital-status/marital';
import { PatientParms, StockModuleSettingsParms } from '../../shared/search-params';
import { ContractComponent, TherapeuticCards } from '../contracts/index';

import { debounceTime, takeUntil } from 'rxjs/operators'; import { Subject } from 'rxjs';
import { SnDocumentType } from '../../document-management/document-type';
import { DocManagementTrans } from '../../document-management/interface/doc-manag-model';
import { Employee } from '../../personnel-setup/employees';
import { GenStockTransService } from '../../stock-transaction/stock-transaction-interface/gen-stock-transaction.service';
import { NewSignalrAlertService, Chat } from '../../shared/new-signalr-alert.service';
import { findInvalidControls } from '../../shared/utility';
import { SheetsHelper } from '../../medical-recored/emr-forms.helper';
import { MedicalRepositoryService } from '../../medical-recored/medical-repository.service';
import { IPromotionsMsgLog } from '../../promotions/promotions';
import { CallCenterReservationService, MsgTemplate } from '../../call-center/call-center-reservation';
import { SmsService } from '../../promotions/SmsService/Sms.service';
import { EmrChronicComponent } from '../../medical-recored/emr-chronic/emr-chronic.component';

@Component({
  selector: 'sanabel-patient',

  templateUrl: './patient.component.html',
  providers: [NameService, FormGroupCreationService, PatientCancelService, GenStockTransService]
})
export class PatientComponent implements OnInit, AfterViewInit, OnDestroy {
  stockSettingsParms: StockModuleSettingsParms = {};
  @ViewChild('emrChronicComponent') emrChronicComponent: EmrChronicComponent;
  private jsonUrl: string = 'setting/country_1.json';
  namingTranslationSettings: number;
  // start i.hamed code
  optianalData: boolean = false;

  toggleOptionalData() {
    this.optianalData = !this.optianalData;
  }
  specailNeeds: boolean = false;
  toggleSpecailNeeds() {
    this.specailNeeds = !this.specailNeeds;
  }

  chronic: boolean = false;
  toggleChronic() {
    this.chronic = !this.chronic;
  }
  // end

  private ngUnsubscribe: Subject<void> = new Subject<void>();
  // private patientImageName: string;
  patientForm: UntypedFormGroup;
  /// family area field */********************************************************************************
  obj = {
    parent: <PatientVM>{},
    family: Array<FamilyDetail>()
  };
  isParentData = true;
  transtag: string;
  relationDegree: number;
  patientData: any;
  addRelativeMode = false;
  patientCode: any;
  messagesLog: IPromotionsMsgLog = <IPromotionsMsgLog>{};
  wordArray = [];
  recordAccantPatient: boolean = false;

  isUploadFile = true;
  editTherapeuticCards: TherapeuticCards = <TherapeuticCards>{};
  @Input()
  public parent: string;
  @Input()
  stepperComponent: StepperComponent;
  @Output()
  private emitSavedPatient: EventEmitter<Patient> = new EventEmitter<Patient>();
  @Output()
  private setActiveIndex: EventEmitter<number> = new EventEmitter<number>();
  // -----------------------------------------------------------------------------------------------------------
  patient: Patient;
  patientCodeCards: number;
  private helper: SheetsHelper = new SheetsHelper();
  editPatient: Patient = <PatientVM>{};
  editContract: boolean = true;
  formValAfterSettings: Patient = <PatientVM>{};
  formValTypeSettings: any = <any>{};
  msgTemplate: MsgTemplate = <MsgTemplate>{};
  editContractPatient: TherapeuticCards = <TherapeuticCards>{};
  identityType: number
  //////patient image file object
  docManagementData: DocManagementTrans = {
    documentLookupCode: SnDocumentType.PersonnalImages,
    dataStatus: undefined
  }; // docmanagement object
  imageContent: string; // used to contain mime type for patrent image
  //////patient cancel
  patientCancel: PatCancel = <PatCancel>{};
  controlsParams: ControlsParams;
  messageId: number;
  patients: Patient[];
  patientParms: PatientParms[];
  hiddenFormControls = new Map()
  myStepNumber = 32;
  isEmergency = false;
  // ********************* ---------------------- *****************************************************************
  @ViewChild('name')
  nameComponent: NameComponent;
  @ViewChild('address')
  addressComponent: AddressComponent;
  @ViewChild('identity')
  identityComponent: IdentityTypeComponent;
  @ViewChild('TherapeuticCards')
  contractComponent: ContractComponent;
  @ViewChild('selectizeContract')
  selectizeContract: ContractComponent;
  //@ViewChild('content', { static: false })
  @ViewChild('content') content: any;

  @ViewChild('btnCtrl1')
  btnCtrl1: any;
  maritalStatusList: MaritalStatus[] = [];
  savePlaceType: number;
  today = {
    year: new Date().getFullYear,
    month: new Date().getMonth,
    day: new Date().getDay()
  };
  // ********************* ---------------------- *****************************************************************


  incubationSerial: number;
  known: boolean;
  //
  phoneNumbers: any = [];
  _phoneNumbers: Patient = <PatientVM>{};
  newEmergencyPatient: IPatientEmergency[] = [];
  toggle;
  constructor(
    private _DirectAddTransService: GenStockTransService,
    private _fb: UntypedFormBuilder,
    private _patientService: PatientService,
    public translate: TranslateService,
    private _modalService: NgbModal,
    private _router: Router,
    private _route: ActivatedRoute,
    private _callCenterReservationService: CallCenterReservationService,
    private _location: Location,
    private _toastService: ToastService,
    private _formServiceSettings: FormSettingsService,
    private _sharedDateService: SharedDateService,
    private _userSessionService: UserSessionService,
    private _namesService: NameService,
    private _newSignalr: NewSignalrAlertService,
    private modalService: ModalService,

    private _SmsService: SmsService, private _medicalRepo: MedicalRepositoryService

  ) {
    this.controlsParams = new ControlsParams(75, AppCodeGroup.Buttons, true);
    this.controlsParams = new ControlsParams(74, AppCodeGroup.Buttons, true);
  }
  // ------------------------------------------------------------keys.value['code']--------
  // ********************* init function ************************s
  patientForEdit: boolean
  ngOnInit() {
    this.getModuleSettings();
    this._userSessionService.setBtnCtrl(this.btnCtrl1);
    this.isEmergency = this._router.url.includes('emergency');
    this.initlizeControls();


    //----------------------//
    // this.getNphiesEligablePatientData$()
    //----------------------//
    this._userSessionService
      .subscribeToKey$('patientForEdit').pipe(
        takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {
        if (keys && keys.name == 'patientForEdit') {
          if (keys.value && keys.value) {
            this.patientForEdit = true
            console.log('patientForEdit ', keys.value)

            this.handelInitParms(keys.value, true);
          }
        }
      });
    this._userSessionService
      .subscribeToKey$('SimilarPatData').pipe(
        takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {
        if (keys && keys.name == 'SimilarPatData') {
          if (keys.value && keys.value) {
            this.similarPatRowIconClick(keys.value);
          }
        }
      });
    this._userSessionService
      .subscribeToKey$('AddNewPatient').pipe(
        takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {
        if (keys && keys.name == 'AddNewPatient') {
          if (keys.value && keys.value) {
            this.resetForm();
          }
        }
      });

    this.myStepper$();
    // this.checkcountryCode();
    this.getJsonDataFile();
    this.getModuleSettingForControlPannel()
  }


  integratesWithNaphise: number;
  integratesWithWaseel  :number;
  getModuleSettingForControlPannel() {
    let stockSettingsParms: any = {}
    this._userSessionService.subscribeToKey$('link')
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(link => {
        if (link.name = 'link') {
          stockSettingsParms.moduleId = 15;
          this._userSessionService.subscribeToKey$('modulesSettings')
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((c: any) => {
              if (c.value) {
                this.integratesWithNaphise = c.value.m_15.IntegratesWithNaphisePlatform
                this.integratesWithWaseel = c.value.m_15.IntegratesWithWaseelPlatform

              }
            })
        }
      })
  }

  patCode: number;
  getPatientToEditByCode() {
    if (this.patCode)
      this.getPatData(this.patCode);
  }


  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  ngAfterViewInit() {
    const _patForEdit = <PatientVM>this._userSessionService.getSessionKey('patientForEdit');
    this._userSessionService.setBtnCtrl(this.btnCtrl1);
    this.initViewComponentForm();
    let setDefaults = true;
    if (_patForEdit && _patForEdit['code'] > 0) {
      setDefaults = false;
    }

    if (!this.isEmergency) {
      this._formServiceSettings.setFormSettings(
        this.patientForm as UntypedFormGroup,
        'patient',
        this.editPatient,
        setDefaults,
        'setting'
      );
      this.checkcountryCode();
    }
    if (this.isEmergency) {
      this._formServiceSettings.setFormSettings(
        this.patientForm as UntypedFormGroup,
        'emergency',
        this.editPatient,
        setDefaults, 'setting'
      );
    }
    this.hiddenFormControls = this._formServiceSettings.hiddenFormControls;
    setTimeout(() => {
      this.formValAfterSettings = <PatientVM>Object.assign({}, this.patientForm.value);
      //       this.formValTypeSettings = <PatientVM>Object.assign({}, this.patientForm.value);
      // this.identityType=this.formValTypeSettings.identity.identityType
      this.handelInitParms(_patForEdit, false);
      this.identityComponent.onIdentitySelected(null)
    }, 100);

    if (this._userSessionService.getSessionKey('reservationCallRegister')) {
      let patSearch = this._userSessionService.getSessionKey('reservationCallRegister');
      setTimeout(() => {

        // this.setCallerDataToForm(patSearch);
        this._userSessionService
          .subscribeToKey$('reservationCallRegister').pipe(
            takeUntil(this.ngUnsubscribe))
          .subscribe((keys: any) => {
            if (keys && keys.name == 'reservationCallRegister') {
              if (keys.value && keys.value) {
                this.setCallerDataToForm(keys.value);
              }
            }
          });

      }, 2000);
    }

    setTimeout(() => {
      this.getNphiesEligablePatientData$()
    }, 500);


  }

  NphiesEligablePatientData = <any>{}
  getNphiesEligablePatientData$() {
    debugger;
    this._userSessionService
      .subscribeToKey$('NphiesEligablePatientData').pipe(
        takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {
        if (keys && keys.name == 'NphiesEligablePatientData') {
          if (keys.value) {
            console.log('NphiesEligablePatientData ', keys.value)
            this.NphiesEligablePatientData = keys.value
            this.patchValueOfNphiesEligablePatientData(keys.value);
          }
        }
      });
  }



  patchValueOfNphiesEligablePatientData(data) {
    let NgbBirthDate = this._sharedDateService.convertFromDateToNgBsObject(data.birthDate)
    console.log('NgbBirthDate_', NgbBirthDate)
    this.nameComponent.getFormGroup().patchValue({
      fnameAr: data.fnameAr,
      snameAr: data.snameAr,
      snameEn: data.snameEn,
      tnameAr: data.tnameAr,
      tnameEn: data.tnameEn,
      lnameAr: data.lnameAr,
      lnameEn: data.lnameEn
    });

    this.patientForm.patchValue({
      birthDateNgb: NgbBirthDate,
      patientOccupation: data.patientOccupation,
      maritalStatus: data.maritalStatus,
    });

    this.patientForm.get('identity').patchValue(
      {
        identityType: data.identityType,
        identityValue: data.identityValue,
        mobile: data.mobile,
        valueFormated: '',
        gender: data.gender
      }
    );
    this.recevTitleCode(data.gender)
    this.identityValueInfoEmitted(data)
    console.log(' this.patientForm _', this.patientForm)
  }

  getNphiesEligablePatientContractData() {
    return this.NphiesEligablePatientData.treatmentCardObj
  }

  countries: any[] = [];
  incubation: number;
  identity: number;
  getJsonDataFile() {
    this._medicalRepo.readJsonFile(this.jsonUrl)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: any) => {
        if (res) {
          this.countries = res.countries
          this.incubation = res.incubation
          this.identity = res.identity

        }
      });

  }


  setMobAlert: boolean
  onMobileKeyUp() {
    let jsonEmpFormSetup
    let mobValue
    mobValue = this.patientForm.get('mobile').value
    console.log('MobValue', mobValue)
    jsonEmpFormSetup = this._formServiceSettings.getFormJsonObj()
    console.log('jsonEmpFormSetup', jsonEmpFormSetup)
    console.log('MobileLength', this.patientForm.get('mobile').value
    )
    if (jsonEmpFormSetup['mobile']['max_length'] < ((this.patientForm.get('mobile').value).length)) {
      this.setMobAlert = true
      this.patientForm.get('mobile').setValue(null)
    }
    else {
      this.setMobAlert = false
      this.patientForm.get('mobile').setValue(mobValue)
    }
  }
  nameAllowNum: boolean = false;
  naphiesFlag: number;
  getModuleSettings() {

    this.stockSettingsParms.moduleId = 42;

    this._DirectAddTransService.getStockModuleSettings(this.stockSettingsParms)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(res => {
        if (res.data && res.data.length > 0) {
          //let settingHM = moduleSettingHashMap(res.data)
          this.namingTranslationSettings = res.data[0]['namingTranslationSettings'];
          if (res.data[0]['possibilityToEnterNumbersInTheName'] == 1) {
            this.nameAllowNum = true;
          }
          else {
            this.nameAllowNum = false;
          }
          this.naphiesFlag = this._userSessionService.integratesWithNaphisePlatform;
          console.log("naphiesFlag= ", this.naphiesFlag);

        }
      });
    //   }
    // });
  }

  // check box for appering discount options
  showRecordAccantPatientOptions(checked: boolean) {



    this.recordAccantPatient = checked;

    this.newEmergencyPatient = [];
    if (checked == true) {
      this._userSessionService.setSessionKey('recordAccantPatient', checked);
    }




  }


  addItem(numArray: number) {
    this.newEmergencyPatient = [];
    for (var i = 0; i < +numArray; i++) {
      this.newEmergencyPatient.push(<IPatientEmergency>{
        gender: 1,
        fnameAr: 'مريض',
        fnameEn: 'patient',
        snameAr: 'طوارئ',
        snameEn: 'Emergency',
        age: 0,
        serialNumber: i + 1,
        code: (i + 1) * -1,
        fullnameAr: 'مريض طوارئ' + (new Date()),
        fullnameEn: 'patient Emergency' + (new Date()),
        birthDate: new Date(),
        docCode: 0

      });
    }



  }

  //___________________ASmaa_____________________
  searchSamePhoneNumbers() {

    this.phoneNumbers = [];
    this._phoneNumbers.mobile = this.patientForm.value.mobile

    this._namesService.findSimilarName(this._phoneNumbers).subscribe(
      searchResult => {
        if (searchResult.data && searchResult.data.length > 0) {
          this.phoneNumbers = searchResult.data;
        }
      }, error => console.log(error),
      () => {
        if (this.phoneNumbers && this.phoneNumbers.length > 0)
          this.modalService.openContent(this.content)
      });

  }

  similarPatRowIconClick(pat: PatientVM) {

    if (pat['flag'] == 'CallCenter') {

      this.getCCCallBeneficiarySimilarPat(pat.code)
    }
    else if (pat['flag'] == 'Patient') {
      this.patientCode = pat.code
      this.getPatData(pat.code);
    }
  }

  //_____________________________________________
  getCCCallBeneficiarySimilarPat(patCode) {
    this._patientService.getCCCallBeneficiarySimilarPat(patCode).pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (patient: any) => {
          if (patient) {

            if (patient.data && patient.data.length > 0) {
              patient.data[0].cCCallBeneficiaryCode = patCode;
              this._setEditPatient(patient.data[0]);
              this.obj.parent = patient.data[0];
            }
            if (patient.data1 && patient.data1.length > 0) {
              this.editContractPatient = patient.data1[0];
            }
          }
        },
        error => console.log(error),
        () => {
          this.setPatientToForm(<PatientVM>this.editPatient);
        }
      );
  }
  //_____________________________________________

  handelInitParms(_patForEdit: PatientVM, resetFlag?: boolean) {
    ;
    if (_patForEdit && _patForEdit['code'] > 0) {
      this.patientCode = _patForEdit['code'];
      this._getPatient();
    } else if (_patForEdit && _patForEdit['AddNew']) {
      this.patientCode = 0;
      this.obj.parent = <PatientVM>{};
      this.setFormBySearchObj(_patForEdit);
    }
  }
  // calcAge
  calcage(e: any) {
    let dob_date = new Date()
    let f = (dob_date.getFullYear() - e.year);
    this.patientForm.get('approxAge').setValue(f);
  }
  /////////////////////get higri date #ibrahim from gregorian date
  getHigriDate() {
    this.editPatient.birthDate = this._sharedDateService.convertFromNgBsToDate(
      this.patientForm.get('birthDateNgb').value
    );

    this._patientService
      .getHigriDate(this.editPatient)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        searchResult => {
          this.patientForm.patchValue({
            dateHijriNgb: this._sharedDateService.convertFromDateToNgBsObject(
              new Date(searchResult.data[0].higriDate)
            )
          });
          console.log(searchResult)
          this.patientForm.get('ageInYear').setValue(searchResult.data1[0].years)
          this.patientForm.get('ageInMonth').setValue(searchResult.data1[0].months)
          this.patientForm.get('ageInDays').setValue(searchResult.data1[0].days)
        },
        error => console.log(error),
        () => null
      );

  }



  ////////////////get gregorian  date #ibrahim from higri
  getGregorianFromHigriDate(ev: any) {
    if (ev && ev.target.value) {
      //console.log(ev.target.value);
      this.editPatient.dateHijri = getDateObj(ev.target.value);
    }
    // console.log(this.editPatient.dateHijri);
    // this.editPatient.dateHijri = new Date(
    //   this.bDhijri.year,
    //   this.bDhijri.month - 1,
    //   this.bDhijri.day
    // );
    //console.log(this.editPatient.dateHijri);
    this._patientService
      .getGregorianDate(this.editPatient).pipe(
        takeUntil(this.ngUnsubscribe))
      .subscribe(
        searchResult => {
          if (searchResult) {
            this.patientForm.get('birthDateNgb').setValue(getNgBsObj(searchResult.data[0].gregorianDate));
          }
          // this.patientForm.patchValue({
          //   birthDate: this._sharedDateService.convertFromDateToNgBsObject(
          //     searchResult.data[0].gregorianDate
          //   )
          // });
          // this.today = getNgBsObj(searchResult.data[0].gregorianDate);
        },
        error => console.log(error),
        () => null
      );
  }

  // getMaritalStatus() {
  //    this._maritalService.getMarital()
  //        .pipe(takeUntil(this.ngUnsubscribe))
  //        .subscribe(resultuser => {
  //            this.maritalStatusList = resultuser.data;
  //        },
  //            err => console.error(err),
  //            () => this.maritalStatusList = this.maritalStatusList)
  // }

  private _getPatient() {

    this.editContractPatient = <TherapeuticCards>{};
    this.resetImageData();
    this.obj.family = [];
    this.obj.parent = <PatientVM>{};

    this.addRelativeMode = false;
    if (this.isAddMode()) {
      this.editPatient = <PatientVM>{};
    } else {
      this.getPatData(this.patientCode)
    }


  }


  getPatData(patCode) {
    this._patientService.getPatient(patCode).pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (patient: any) => {
          if (patient) {

            if (patient.data && patient.data.length > 0) {
              this._setEditPatient(patient.data[0]);
              this.obj.parent = patient.data[0];
            }
            if (patient.data1 && patient.data1.length > 0) {
              this.editContractPatient = patient.data1[0];
            }
          }
        },
        error => console.log(error),
        () => {
          this.setPatientToForm(<PatientVM>this.editPatient);
        }
      );
  }
  contractIsEditable() {
    return this.patientCode > 0 ? false : true;
  }
  private getPatientImage(patientCode) {
    // this.
  }
  // -------------------------------------------------------------------------------------------------------------
  // ********************************************* used to inial value for selectize in edit mode ****************************************
  /**
   * call after identity value change and emit object contain gender birth place and date for egyption id
   * @param event
   */
  identityValueInfoEmitted(event) {
    debugger;

    const DOB = this._sharedDateService.convertFromDateToNgBsObject(
      event.birthDate
    );
    let x = (new Date().getFullYear() - DOB.year)
    this.patientForm.patchValue({
      birthDateNgb: DOB,
      birthPlace: event.birthPlace,
      gender: event.gender,
      ageYear: DOB.year,
      ageMonth: DOB.month,
      ageDay: DOB.day,
      approxAge: x,
    });
    this.getHigriDate();
  }

  clacBirthDateFromAge(_year: number, _month: number, _days: number) {

    let _birthDate = this._sharedDateService.dateFromAge(
      +_year, +_month, +_days
    );
    let DOB = this._sharedDateService.convertFromDateToNgBsObject(
      _birthDate
    );
    _birthDate
    this.patientForm.patchValue({
      birthDateNgb: DOB
    });

    this.getHigriDate();
  }

  contractValueInfoEmitted(event) {
    (<UntypedFormControl>this.patientForm.controls['contractId']).setValue(event);
  }


  // ----------#gouhar emit contract----------------------------------------------------------------------
  // ********* read data from emit for child component ***************************************************
  private _setEditPatient(patient: PatientVM) {
    this.editPatient = patient;
    this.patientCode = this.editPatient.code

    // this.imageContent = this.editPatient['imagePath']; // contain mime type for image
    this.resetDocManagmentData();
    this.savePlaceType = this.editPatient.savePlaceType;
    if ((this.savePlaceType == 4 || this.savePlaceType == 1) && (this.editPatient['docPath'] && this.editPatient['docPath'] != null)) {
      this.docManagementData.base64 = this.editPatient['docPath'];
      this.docManagementData.dataStatus = 2;
      this.docManagementData.serial = this.editPatient['docManagementTransSerial'];
    }
    else
      if ((this.editPatient['base64'] && this.editPatient['base64'] != null) || this.editPatient['dbDocSerial'] > 0) {
        this.docManagementData.base64 = this.editPatient['base64']; // contain encoded image base 64
        this.docManagementData.dbDocSerial = this.editPatient['dbDocSerial'];
        this.docManagementData.dataStatus = 2;
        this.docManagementData.serial = this.editPatient['docManagementTransSerial'];

      }
  }

  resetDocManagmentData() {
    this.docManagementData.base64 = undefined; // contain encoded image base 64
    this.docManagementData.dbDocSerial = undefined;
    this.docManagementData.dataStatus = undefined;
  }


  OutSavePlaceType(e) {
    this.savePlaceType = e;
  }
  // ---------------------------------------------------------------------------------
  // ******************************************* create reactive form  and bulid form bulider ***************************
  /**
   * used to init patient form controls
   */
  initlizeControls() {
    this.patientForm = this._fb.group({
      code: 0,
      customCode: [''],
      numberPatient: 0,
      howToReachUs: [''],
      dateHijri: new Date(),
      oldCode: '',
      name: this._fb.group({}),
      therapeuticCards: this._fb.group({}),
      address: this._fb.group({}),
      identity: this._fb.group({}),
      gender: null,
      birthDateNgb: null,
      ageYear: undefined,
      ageMonth: undefined,
      ageDay: undefined,
      approxAge: undefined,
      ageInYear: null,
      ageInMonth: null,
      ageInDays: null,
      birthPlace: [''],
      homePhone: '',
      mailAddress: [''],
      mobile: [''],
      countryKey:'',
      fatherName: '',
      motherName: '',
      nickName: '',
      visitDays: 0,
      heelSampleFlag: 0,
      hepatitisEpidemicSampleFlag: 0,
      parentId: '',
      employeeId: '',
      fileNo: '',
      religionId: [''],
      maritalStatus: [''],
      patientOccupation: [''],
      bloodGroup: '',
      rhValue: '',
      contractId: '',
      stopFlag: '',
      vipFlag: '',
      mortaliyFlag: '',
      mortalityDate: '',
      vipLevel: '',
      dateHijriNgb: null,
      mortalityDateNgb: null,
      specialNeedType: null,
      specialNeedDesc: '',
      cCCallBeneficiaryCode: null
    });


  }
  checkValidation() {
    this.checkcountryCode()
  }
  //___________________sayed_____________________
  checkcountryCode() {
    if (this.patientForm.contains('address.countryCode'))
      console.log('this.patientForm in checkcountryCode_', this.patientForm)
    this.patientForm.get('mobile').clearValidators();
    this.patientForm.get('address.countryCode')
      .valueChanges
      .subscribe(selectedValue => {
        if (selectedValue) {
          this.countries.forEach(el => {
            if (el.code == selectedValue) {
              if (el.regex && el.regex.length > 0) {
                this.patientForm.get('mobile').setValidators([
                  Validators.pattern(new RegExp(el.regex ? el.regex : ''))
                ]);
              } else {
                this.patientForm.get('mobile').clearValidators();
                this.patientForm.get('mobile').updateValueAndValidity();
              }
              this.patientForm.get('mobile').updateValueAndValidity();
            }
          });
        }
        else {
          this.patientForm.get('mobile').clearValidators();
          this.patientForm.get('mobile').updateValueAndValidity();
        }

      });
  }


  getStopFlag(ev) {
    if (ev == true) {
      this.editPatient.stopFlag = 1
      this.patientForm.get('stopFlag').setValue(1)
    }
    else if (ev == false) {
      this.editPatient.stopFlag = 0
      this.patientForm.get('stopFlag').setValue(0)

    }
  }

  /**
   * used to init form group that used in views component
   * call after view init
   */
  initViewComponentForm() {
    if (this.nameComponent) {
      this.patientForm.setControl('name', this.nameComponent.getFormGroup());
    }
    if (this.addressComponent) {
      this.patientForm.setControl(
        'address',
        this.addressComponent.getAddressForm()
      );
    }
    if (this.identityComponent) {
      this.patientForm.setControl(
        'identity',
        this.identityComponent.getIdentityForm()
      );
    }

    if (this.contractComponent) {
      this.patientForm.setControl(
        'TherapeuticCards',
        this.contractComponent.getTherapeuticCardsFormGroup()
      );
    }
  }

  // ---------------------------------------------------------------------------------------------------------------------
  updateControl(key: UntypedFormControl, value) {
    this.patientForm.patchValue({
      key: value
    });
  }
  // ********************************************** btns area ***********************************************************
  onClicked(e: number): void {
    switch (e) {
      case 1: // save code
      case -1000:
        this.isUploadFile = true;
        setTimeout(() => this.save(), 0);
        break;
      case 3:
        this.patCancel();
        break;
      case 2:
        this.goSearchPatient();
        break;
      case 23:
        this.resetForm();
        break;
      default:
        this.cancel();
    }
  }
  // ---------------------------------------------------------------------------------------------------------------------
  // ******************************************* btn save function  *****************************************************************
  txtMessage: string = 'تم تسجيل مريض جديد';
  uniqueID: string = new Date().getTime().toString();
  message = new Chat();
  sendMessage(): void {
    if (this.txtMessage) {
      this.message = new Chat();
      this.message.clientuniqueid = this.uniqueID;
      this.message.type = "sent";
      this.message.message = this.txtMessage;
      this.message.date = new Date();
      this._newSignalr.sendMessage(this.message);
      this.txtMessage = '';
    }
  }


  /**
   * send patient or set of patient family to api
   */

  checkValidationData: number
  patObj: PatientData = <PatientData>{};
  patarray: PatientData[] = [];
  save() {
    const patientdata = <PatientData>{ docManagementData: null };
    patientdata.familyPatients = [];
    patientdata.patients = [];
    patientdata.familyDetail = this.obj.family;
    if (this.contractComponent)
      this.editTherapeuticCards = this.contractComponent.getTherapeuticCardsForm();
    patientdata.therapeuticCards = this.editTherapeuticCards;

    patientdata.patient = this.getPatientFromForm();
    patientdata.patient.stopFlag = this.editPatient.stopFlag
    patientdata.patient['checkValidation'] = this.checkValidationData
    patientdata.patient['regIncubationPatMainDataSerial'] = this.incubationSerial //basma

    if (this.editTherapeuticCards)
      patientdata.patient.contractId = this.editTherapeuticCards.contractId;
    patientdata.docManagementData = this.docManagementData;

    /****************************************************************************************************/
    const controlErrors: string[] = [];
    // patientdata.patient['checkValidation']=0
    if (!this.recordAccantPatient) {
      const dob = patientdata.patient.birthDate;
      if (this.isEmergency && (dob == null || String(dob) == '')) {
        const dt = {
          year: this.patientForm.get('ageYear').value,
          month: this.patientForm.get('ageMonth').value || 1,
          day: this.patientForm.get('ageDay').value || 1
        };
        patientdata.patient.birthDate = this._sharedDateService.convertFromNgBsToDate(
          dt
        );
      }
    }
    if (!patientdata.patient.mobile && patientdata.patient.identityType != 5) {
      this._toastService.activateMsg('UI600');
      return;
    }

    if (patientdata.patient.nationalityId == 63 && patientdata.patient.identityType != 1 && this.identity == 1) {
      this._toastService.activateMsg('UI341');
      return;
    }
    if (patientdata.patient.nationalityId == null && (this.integratesWithNaphise ==1 || this.integratesWithWaseel == 1)) {
      this._toastService.activateMsg('UI605');
      return;
    }
    if (patientdata.patient.mobile == null && (this.integratesWithNaphise ==1 || this.integratesWithWaseel == 1)) {
      this._toastService.activateMsg('UI606');
      return;
    }
    if (this.naphiesFlag == 1 && !patientdata.patient.maritalStatus) {
      this._toastService.activateMsg('MaritalStatus');
      return;
    }
    if (this.naphiesFlag == 1 && !patientdata.patient.patientOccupation) {
      this._toastService.activateMsg('PATIENTOCCUPATION');
      return;
    }
    if (!this.recordAccantPatient && this.unKnownFlag != 1) {
      if (this.patientForm.invalid) {
        let _invalid = findInvalidControls(this.patientForm);
        console.log(_invalid)
        this._toastService.activateMsg('GeneralError');
        return;

      }

      if (patientdata.patient.contractId == undefined || patientdata.patient.contractId == null) {
        this._toastService.activateMsg('UI36');
        return;
      }


    }

    // ****************************************************************************************************/
    if (this.recordAccantPatient) {
      this.newEmergencyPatient.forEach(x => {
        let date = new Date();
        x.birthDate = new Date(date.setFullYear(date.getFullYear() - x.age));
      })
    }
    this._userSessionService.setSessionKey('NewEmergencyPatient', this.newEmergencyPatient);
    patientdata.patients = this.recordAccantPatient ? this.newEmergencyPatient : [patientdata.patient]
    // ---------chronic---------------------
    if (this.emrChronicComponent) {
      this.emrChronicComponent.save()
    }
    const patChronic = <any>this._userSessionService.getSessionKey('PatientNewChronic');
    patientdata.emrPatHistory = patChronic
    patientdata.patient.unKnownFlag = this.unKnownFlag;
    console.log('patChronic', patChronic)
    console.log('patientdata', patientdata)

    if (this.isAddMode()) {
      this._patientService
        .addPatient(patientdata).pipe(
          takeUntil(this.ngUnsubscribe))
        .subscribe(
          pa => {
            if (pa['returnFlag'] == true) {
              if (pa.data && pa.data.length > 0) {
                this.patObj = pa.data[0];
                this.patarray = pa.data;
                this._userSessionService.setSessionKey('NewEmergencyPatient', this.patarray);
                this._userSessionService.setSessionKey('PatientNewChronic', null);

                this.sendMessage();
                this.handelSaveResult(pa);

                // this.modalService.activeMes(`?هل تريد ارسال رساله تاكيد للمريض`, `Do you want to send a confirmation message to the patient?`).then(responseOK => {
                //   if (responseOK) {
                //     this.saveMessagesLog()
                //   } else {


                //   }
                // })
              }
            }
          },
          error => console.log(error),
          () => {
          }
        );
    } else {
      this._patientService
        .updatePatient(patientdata).pipe(
          takeUntil(this.ngUnsubscribe))
        .subscribe(
          pa => {
            if (patientdata.patient['checkValidation'] != 1) {
              if (pa['msgData'] && pa['msgData'][0] && pa['msgData'][0]['msgType'] == 3) {
                this.modalService.activeMes(pa['msgData'][0].msgBodyAr, pa['msgData'][0].msgBodyEn).then(responseOK => {
                  if (responseOK) {
                    this.checkValidationData = 1
                    this.save()
                  } else {
                    this.checkValidationData = 0
                  }
                })
              }
            } else {
              patientdata.patient['checkValidation'] = 0
              this.patObj = pa.data[0];
              this.handelSaveResult(pa);
            }
          },
          error => console.log(error),
          () => {
            if (this.messageId == 5) {

            }
          }
        );
    }
    this.newEmergencyPatient = []
  }
  /**
   * after save work handling
   */
  handelSaveResult(pa: any) {
    if (pa.msgData && pa.msgData[0]['msgID'] == 5) {
      this.editPatient = pa.data[0];
      this.editPatient.customCode = pa.data[0]['customCode'];
      this.editPatient.code = pa.data[0]['code'];
      this.editPatient['patientCode'] = this.editPatient.code;
      this.editPatient['patCode'] = this.editPatient.code;
      const _savedPat = Object.assign({}, this.editPatient);
      this.emitSavedPatient.emit(_savedPat);
      // this.emitSavedPatient.emit( pa.data[0]);
      this._userSessionService.setSessionKey('patientBanner', pa.data[0]);
    }
    this.obj.parent = <PatientVM>this.editPatient;
  }
  // ******************************************* btn cancel function  *******************************************
  /**
   * go back one step out
   */
  cancel() {
    this._goBack();
  }
  // -------------------------------------------------------------------------------------------------------------
  patCancel() {
    if (this.editPatient.code == undefined) {
      return;
    } else {
      this._router.navigate(['patcancel'], { relativeTo: this._route });
      this.openModal();
    }
  }
  openModal(): void {
    this._modalService.open(this.content).result.then(
      result => {
        this._location.back();
      },
      reason => { }
    );
  }
  // ---------------------------------------------------------------------------------------------------------------------
  _goBack(): void {
    this._location.back();
  }

  isAddMode() {

    if (this.patientCode > 0) {
      return false;
    } else {
      return true;
    }
  }

  onOutBase64(event) {
    this.docManagementData.base64 = event;
    if (this.docManagementData.dataStatus == undefined) {
      this.docManagementData.dataStatus = 1;
    }
  }


  // ---------------------------------------------------------------------------------------------------------------------
  /**
   * get patient object form formGroup
   * return patient object
   */
  getPatientFromForm(): any {
    const dummy = <PatientVM>this.patientForm.value;
    const _formValue = Object.assign({}, dummy);
    _formValue.titleCode = _formValue.name.titleCode;
    _formValue.fnameAr = _formValue.name.fnameAr;
    _formValue.fnameEn = _formValue.name.fnameEn;

    _formValue.snameAr = _formValue.name.snameAr;
    _formValue.snameEn = _formValue.name.snameEn;

    _formValue.tnameAr = _formValue.name.tnameAr;
    _formValue.tnameEn = _formValue.name.tnameEn;

    _formValue.lnameAr = _formValue.name.lnameAr;
    _formValue.lnameEn = _formValue.name.lnameEn;
    if (this.nameComponent && !this.recordAccantPatient) {
      _formValue.fullnameAr = this.nameComponent.getFullNameAr();
      _formValue.fullnameEn = this.nameComponent.getFullNameEn();

    }

    ///checkname

    switch (+this.namingTranslationSettings) {
      case 3:
        _formValue.fnameEn = _formValue.fnameAr;
        _formValue.snameEn = _formValue.snameAr;
        _formValue.tnameEn = _formValue.tnameAr;
        _formValue.lnameEn = _formValue.lnameAr;
        _formValue.fullnameEn = _formValue.fullnameAr;
        break;
      case 4:
        _formValue.fnameAr = _formValue.fnameEn;
        _formValue.snameAr = _formValue.snameEn;
        _formValue.tnameAr = _formValue.tnameEn;
        _formValue.lnameAr = _formValue.lnameEn;
        _formValue.fullnameAr = _formValue.fullnameEn;
        break;

      default:
        _formValue.fnameAr = _formValue.name.fnameAr;
        _formValue.fnameEn = _formValue.name.fnameEn;

        _formValue.snameAr = _formValue.name.snameAr;
        _formValue.snameEn = _formValue.name.snameEn;

        _formValue.tnameAr = _formValue.name.tnameAr;
        _formValue.tnameEn = _formValue.name.tnameEn;

        _formValue.lnameAr = _formValue.name.lnameAr;
        _formValue.lnameEn = _formValue.name.lnameEn;
        if (this.nameComponent && !this.recordAccantPatient) {
          _formValue.fullnameAr = this.nameComponent.getFullNameAr();
          _formValue.fullnameEn = this.nameComponent.getFullNameEn();
        }
        break;
    }

    ////--------------------------------------get therapeuticCards object--------------
    _formValue.therapeuticCards.policyNumber =
      _formValue.therapeuticCards.policyNumber;
    // _formValue.therapeuticCards.cardNo = _formValue.therapeuticCards.cardNo;
    ///--------------------------------------------------------------------------------

    // _formValue.fullnameAr = _formValue.name.fullnameAr;
    // _formValue.fullnameEn = _formValue.name.fullnameEn;

    _formValue.countryCode = _formValue.address.countryCode;

    _formValue.govCode = _formValue.address.govCode;
    _formValue.cityCode = _formValue.address.cityCode;
    _formValue.villageCode = _formValue.address.villageCode;
    _formValue.nationalityId = _formValue.address.nationalityId;

    _formValue.fullAddressAr = _formValue.address.fullAddressAr;
    _formValue.fullAddressEn = _formValue.address.fullAddressEn;

    _formValue.identityType = _formValue.identity.identityType;
    _formValue.identityValue = _formValue.identity.identityValue;
    // _formValue.mobile =_formValue .identity.;
    _formValue.birthDate = this._sharedDateService.convertFromNgBsToDate(
      _formValue.birthDateNgb
    );
    _formValue.dateHijri = this._sharedDateService.convertFromNgBsToDate(
      _formValue.dateHijriNgb
    );
    _formValue.mortalityDate = this._sharedDateService.convertFromNgBsToDate(
      _formValue.mortalityDateNgb
    );
    delete _formValue.name;
    delete _formValue.address;
    delete _formValue.identity;
    delete _formValue.dateHijriNgb;
    delete _formValue.birthDateNgb;
    delete _formValue.mortalityDateNgb;
    delete _formValue.therapeuticCards;

    return _formValue;
  }
  // ---------------------------------------------------------------------------------------------------------------------
  setPatientToForm(patient: PatientVM) {

    if (this.nameComponent && patient.name == undefined) {
      patient.name = this.nameComponent.getNameObjFromModel(patient);
    }

    if (this.addressComponent && patient.address == undefined) {
      patient.address = this.addressComponent.getAddressObjFromModel(patient);
      this.addressComponent.updateFormGroup(patient.address);
    }

    patient.identity = <IIdentity>{};
    patient.dateHijriNgb = this._sharedDateService.convertFromDateToNgBsObject(
      patient.dateHijri
    );
    patient.birthDateNgb = this._sharedDateService.convertFromDateToNgBsObject(
      patient.birthDate
    );
    patient.mortalityDateNgb = this._sharedDateService.convertFromDateToNgBsObject(
      patient.mortalityDate
    );
    patient.therapeuticCards = <TherapeuticCards>{};
    (<UntypedFormGroup>this.patientForm).patchValue(patient, {
      onlySelf: true,
      emitEvent: false
    });
    this.patientForm.get('identity').patchValue(
      {
        identityType: patient.identityType,
        identityValue: patient.identityValue,
        mobile: patient.mobile,
        valueFormated: '',
        gender: patient.gender
      },
      { emitEvent: false }
    );

    if (patient['AddNew'] && patient.identityValue) {
      this.identityComponent.onIdentityValueBlur();
    }

    if (
      this.editContractPatient &&
      Object.keys(this.editContractPatient).length > 0
    ) {
      this.editContractPatient.patientCode = patient.code;
      this.contractComponent.setFormGroup(this.editContractPatient);
    } else {
      if (this.contractComponent) {
        this.editContractPatient = this.contractComponent.getNewInstance(
          patient.code,
          patient.contractId,
        );
      }

    }


  }
  /*************************************************************************************************************
   *
   * @param name
   * @param value
   */
  updateFormControl(name: UntypedFormControl, value: string) {
    this.patientForm.patchValue({ name: value });
  }

  // ---------------------------------------------------------------------------------------------------------------------
  // ********************* family area  *****************************************************************
  selectFamilyMemberType(relativeCode: string) {
    this.changerelativetranstag(relativeCode);
    if (relativeCode == '') {
      this.resetForm();
      this.isParentData = true;
    }
    this.addRelativeMode = true;
    switch (relativeCode) {
      case '1':
        this.fatherCase();
        break;
      case '2':
        this.motherCase();
        break;
      case '3':
        this.brotherCase();
        break;
      case '4':
        this.sisterCase();
        break;
      case '5':
        this.sonCase();
        break;
      case '6':
        this.daughterCase();
        break;
      case '7':
        this.husbandCase();
        break;
      case '8':
        this.wifeCase();
        break;
    }
  }
  // family handling
  fatherCase() {
    if (this.obj.parent != undefined) {
      const familyMember = <PatientVM>{};
      familyMember.fnameAr = this.obj.parent.snameAr;
      familyMember.fnameEn = this.obj.parent.snameEn;
      familyMember.snameAr = this.obj.parent.tnameAr;
      familyMember.snameEn = this.obj.parent.tnameEn;
      familyMember.tnameAr = this.obj.parent.lnameAr;
      familyMember.tnameEn = this.obj.parent.lnameEn;
      familyMember.gender = 1;
      this._setEditPatient(familyMember);
    }
  }
  motherCase() {
    if (this.obj.parent != undefined) {
      const parent = this.getPatientFromForm();
      this.resetForm();
      this.obj.parent = parent;
      const familyMember = <PatientVM>{};
      familyMember.parentId = this.obj.parent.code;
      familyMember.gender = 2;
      this.patientForm.patchValue({ parentId: familyMember.parentId });
      this._setEditPatient(familyMember);
    }
  }
  brotherCase() {
    if (this.obj.parent != undefined) {
      const parent = this.getPatientFromForm();
      this.resetForm();
      this.obj.parent = parent;
      const familyMember = <PatientVM>{};
      familyMember.parentId = this.obj.parent.code;
      familyMember.gender = 1;
      this.nameComponent.getFormGroup().patchValue({
        fnameAr: '',
        snameAr: this.obj.parent.snameAr,
        snameEn: this.obj.parent.snameEn,
        tnameAr: this.obj.parent.tnameAr,
        tnameEn: this.obj.parent.tnameEn,
        lnameAr: this.obj.parent.lnameAr,
        lnameEn: this.obj.parent.lnameEn
      });

      this.patientForm.patchValue({ parentId: familyMember.parentId });
      this._setEditPatient(familyMember);
    }
  }
  sisterCase() {
    // tslint:disable-next-line:triple-equals
    if (this.obj.parent != undefined) {
      const parent = this.getPatientFromForm();
      this.resetForm();
      this.obj.parent = parent;

      const familyMember = <PatientVM>{};
      familyMember.parentId = this.obj.parent.code;
      familyMember.gender = 2;

      this.nameComponent.getFormGroup().patchValue({
        fnameAr: '',
        snameAr: this.obj.parent.snameAr,
        snameEn: this.obj.parent.snameEn,
        tnameAr: this.obj.parent.tnameAr,
        tnameEn: this.obj.parent.tnameEn,
        lnameAr: this.obj.parent.lnameAr,
        lnameEn: this.obj.parent.lnameEn
      });

      this.patientForm.patchValue({ parentId: familyMember.parentId });
      this._setEditPatient(familyMember);
    }
    // tslint:disable-next-line:triple-equals
    if (this.obj.parent != undefined) {
      const familyMember = <PatientVM>{};
      familyMember.snameAr = this.obj.parent.snameAr;
      familyMember.snameEn = this.obj.parent.snameEn;
      familyMember.tnameAr = this.obj.parent.tnameAr;
      familyMember.tnameEn = this.obj.parent.tnameEn;
      familyMember.lnameAr = this.obj.parent.lnameAr;
      familyMember.lnameEn = this.obj.parent.lnameEn;
      familyMember.gender = 2;

      this._setEditPatient(familyMember);
    }
  }
  sonCase() {
    if (this.obj.parent != undefined) {
      const parent = this.getPatientFromForm();
      this.resetForm();
      this.obj.parent = parent;

      const familyMember = <PatientVM>{};
      familyMember.parentId = this.obj.parent.code;

      if (this.obj.parent.gender == 1) {
        this.nameComponent.getFormGroup().patchValue({
          fnameAr: '',
          snameAr: this.obj.parent.fnameAr,
          snameEn: this.obj.parent.fnameEn,
          tnameAr: this.obj.parent.snameAr,
          tnameEn: this.obj.parent.snameEn,
          lnameAr: this.obj.parent.tnameAr,
          lnameEn: this.obj.parent.tnameEn
        });
      }
      this.patientForm.patchValue({ parentId: familyMember.parentId });
      this._setEditPatient(familyMember);
    }
  }
  daughterCase() {

    if (this.obj.parent != undefined) {
      const parent = this.getPatientFromForm();
      this.resetForm();
      this.obj.parent = parent;

      const familyMember = <PatientVM>{};
      familyMember.parentId = this.obj.parent.code;
      familyMember.gender = 2;
      if (this.obj.parent.gender == 1) {
        this.nameComponent.getFormGroup().patchValue({
          fnameAr: '',
          snameAr: this.obj.parent.fnameAr,
          snameEn: this.obj.parent.fnameEn,
          tnameAr: this.obj.parent.snameAr,
          tnameEn: this.obj.parent.snameEn,
          lnameAr: this.obj.parent.tnameAr,
          lnameEn: this.obj.parent.tnameEn
        });
      }
      this.patientForm.patchValue({ parentId: familyMember.parentId });
      this._setEditPatient(familyMember);
    }
  }

  husbandCase() {
    if (this.obj.parent != undefined) {
      const parent = this.getPatientFromForm();
      this.resetForm();
      this.obj.parent = parent;
      const familyMember = <PatientVM>{};
      familyMember.parentId = this.obj.parent.code;
      familyMember.gender = 1;
      this.patientForm.patchValue({ parentId: familyMember.parentId });
      this._setEditPatient(familyMember);
    }
  }
  wifeCase() {
    if (this.obj.parent != undefined) {
      const parent = this.getPatientFromForm();
      this.resetForm();
      this.obj.parent = parent;
      const familyMember = <PatientVM>{};
      familyMember.parentId = this.obj.parent.code;
      familyMember.gender = 2;
      this.patientForm.patchValue({ parentId: familyMember.parentId });
      this._setEditPatient(familyMember);
    }
  }

  // assign translate tag
  changerelativetranstag(transtag: string) {
    this.relationDegree = +transtag;
    if (transtag == '5') {
      this.transtag = 'REGSON';
    } else if (transtag == '6') {
      this.transtag = 'REGDAUGHTER';
    } else if (transtag == '7') {
      this.transtag = 'REGHUSBND';
    } else if (transtag == '8') {
      this.transtag = 'REGWIFE';
    }
  }

  get maritalStatus() {
    // 'Code': 2, 'nameAr': 'أعزب',
    // 'Code': 3, 'nameAr': 'أرمل',
    // 'Code': 4, 'nameAr': 'مطلق',
    const ms = this.patientForm.get('maritalStatus').value;
    // tslint:disable-next-line:triple-equals
    const state =
      ms == 0 || ms == null || ms == 2 || ms == 3 || ms == 4 ? true : false;
    return state;
  }

  addrelative() {
    const familyMember = <FamilyDetail>{};
    familyMember.relationDegree = this.relationDegree;
    familyMember.parentId = this.obj.parent.code;
    this._userSessionService.setSessionKey("relativeParent", familyMember.parentId)
    this.obj.family.push(familyMember);
    this.save();
  }

  canceladdrelative() {
    this._setEditPatient(this.obj.parent);
    this.setPatientToForm(this.obj.parent);

    this.addRelativeMode = false;
  }

  resetForm() {
    const _patForEdit = <PatientVM>(
      Object.assign({}, {})
    );
    _patForEdit['AddNew'] = true;
    _patForEdit['code'] = 0;
    _patForEdit['customCode'] = '';

    this.patientCode = 0;

    this.setPatientToForm(<PatientVM>_patForEdit);


    this.resetImageData();
    this.obj.family = [];
    this.obj.parent = <PatientVM>{};
    this._formServiceSettings.setFormSettings(
      this.patientForm as UntypedFormGroup,
      'patient',
      this.editPatient,
      true,
      'setting'
    );
  }

  editaddrelative(x) {
    this.setPatientToForm(x);
    this.addRelativeMode = true;
  }

  setFormBySearchObj(_searchObj: PatientVM) {

    const _newSearchObj = <PatientVM>(
      Object.assign({}, this.formValAfterSettings)
    );
    if (_searchObj == null || _searchObj == undefined) {
      _searchObj = _newSearchObj;
    }
    _newSearchObj.mobile = _searchObj.mobile
      ? _searchObj.mobile
      : _newSearchObj.mobile;
    _newSearchObj.gender = _searchObj.gender
      ? _searchObj.gender
      : _newSearchObj.gender;
    _newSearchObj.fastSearchData = _searchObj.fastSearchData
      ? _searchObj.fastSearchData
      : _newSearchObj.fastSearchData;
    _newSearchObj.fullnameEn = _searchObj.fullnameEn
      ? _searchObj.fullnameEn
      : _newSearchObj.fullnameEn;
    _newSearchObj.identityValue = _searchObj.identityValue
      ? _searchObj.identityValue
      : _newSearchObj.identityValue;
    _newSearchObj.contractId = _searchObj.contractId
      ? _searchObj.contractId
      : _newSearchObj.contractId;

    if (_newSearchObj.address) {
      _newSearchObj.address.countryCode = _searchObj.countryCode ? _searchObj.countryCode : _newSearchObj.address.countryCode;
      _newSearchObj.address.govCode = _searchObj.govCode ? _searchObj.govCode : _newSearchObj.address.govCode;
      _newSearchObj.address.nationalityId = _searchObj.nationalityId
        ? _searchObj.nationalityId
        : _newSearchObj.address.nationalityId;
    }

    _newSearchObj['AddNew'] = true;

    if (
      +_newSearchObj.fastSearchData > 0 &&
      _newSearchObj.fastSearchData.length == 14
    ) {
      _newSearchObj.identityValue = _newSearchObj.fastSearchData;
      _newSearchObj.identityType = 1;
    } else if (
      _newSearchObj.identityValue &&
      _newSearchObj.identityValue.toString().length == 14
    ) {
      _newSearchObj.identityType = 1;
    }

    if (_newSearchObj.fullnameEn && _newSearchObj.fullnameEn.length > 0) {
      _newSearchObj.name = this.nameComponent.splitFullNameAr(
        _newSearchObj.fullnameEn,
        _newSearchObj.titleCode
      );
    } else if (
      _newSearchObj.fastSearchData &&
      isNaN(+_newSearchObj.fastSearchData) &&
      _newSearchObj.fastSearchData.length > 0
    ) {
      _newSearchObj.fullnameEn = _newSearchObj.fastSearchData;
      _newSearchObj.name = this.nameComponent.splitFullNameAr(
        _newSearchObj.fullnameEn,
        _newSearchObj.titleCode
      );
    }
    this.setPatientToForm(_newSearchObj);
  }
  // used to reset image if you add patient after edit one
  resetImageData() { }
  // ----------------------------subscribe
  myStepper$() {
    this._userSessionService.setBtnCtrl(this.btnCtrl1);
    if (this.stepperComponent) {
      this.stepperComponent
        .getCurrentStep().pipe(
          takeUntil(this.ngUnsubscribe))
        .subscribe(step => {
          if (step && step['serial'] == this.myStepNumber) {
            this.resetForm();
            this._userSessionService.setBtnCtrl(this.btnCtrl1);
          }
        });
    }
  }

  /*
  sayed
  */
  setCallerDataToForm(ev: any) {
    ////// if (ev && ev.code && !ev.AutoEmited)    ///___Comented By Asmaa
    if (ev && !ev.AutoEmited) {
      Object.keys(ev).forEach(key => {
        if (ev[key] == undefined || ev[key] == null) {
          ev[key] = typeof (ev[key]) == 'number' ? 0 : '';
        }
      });
      //============================//
      //BASMA____________
      if (ev.tableName == 'Reg_IncubationPatMainData') {
        this.incubationSerial = ev.code;
      }

      //============================//
      ////______ASMAA_______Splite ev.fastSearchData To FnameAr,Sname,Tname
      var str = ev.fastSearchData
      if (str) {
        var splitted = str.split(" ", 4)
        console.log(splitted)
      } else splitted = []
      ///______els_________________________________
      this.patientForm.get('cCCallBeneficiaryCode').setValue(ev.code);
      this.patientForm.get('howToReachUs').setValue(ev.howToReachUs);
      if (ev.birthDate) {
        this.patientForm.get('birthDateNgb').setValue(this._sharedDateService.convertFromDateToNgBsObject(
          ev.birthDate
        ));
      }
      ////// ASMAA /////
      this.patientForm.get('name.fnameEn').setValue(ev.fnameEn ? ev.fnameEn : splitted[0] ? splitted[0] : '');
      this.patientForm.get('name.snameEn').setValue(ev.snameEn ? ev.snameEn : splitted[1] ? splitted[1] : '');
      this.patientForm.get('name.tnameEn').setValue(ev.tnameEn ? ev.tnameEn : splitted[2] ? splitted[2] : '');
      this.patientForm.get('name.lnameEn').setValue(ev.lnameEn ? ev.lnameEn : splitted[3] ? splitted[3] : '');


      this.patientForm.get('name.fnameAr').setValue(ev.fnameAr ? ev.fnameAr : splitted[0] ? splitted[0] : '');
      this.patientForm.get('name.snameAr').setValue(ev.snameAr ? ev.snameAr : splitted[1] ? splitted[1] : '');
      this.patientForm.get('name.tnameAr').setValue(ev.tnameAr ? ev.tnameAr : splitted[2] ? splitted[2] : '');
      this.patientForm.get('name.lnameAr').setValue(ev.lnameAr ? ev.lnameAr : splitted[3] ? splitted[3] : '');

      //  this.patientForm.get('name.fnameAr').setValue( ev.fnameEn );
      //  this.patientForm.get('name.snameAr').setValue( ev.snameEn );
      //  this.patientForm.get('name.tnameEn').setValue( ev.tnameEn );
      //  this.patientForm.get('name.lnameEn').setValue( ev.lnameEn );

      this.patientForm.get('mobile').setValue(ev.mobile);
      this.patientForm.get('homePhone').setValue(ev.homePhone);
      this.patientForm.get('address.countryCode').setValue(ev.countryCode);
      this.patientForm.get('address.govCode').setValue(ev.govCode);
      this.patientForm.get('address.fullAddressAr').setValue(ev.fullAddressAr);
      this.patientForm.get('address.fullAddressEn').setValue(ev.fullAddressEn);
      // this.patientForm.get('name.tnameAr').setValue(ev.tnameAr);
      // this.patientForm.get('name.lnameAr').setValue(ev.lnameAr);
      this.patientForm.get('address.nationalityId').setValue(ev.nationalityId > 0 ? ev.nationalityId : ev.countryCode);

      this.patientForm.get('identity.identityType').setValue(ev.identityType);
      this.patientForm.get('identity.identityValue').setValue(ev.identityValue);
      this.patientForm.get('contractId').setValue(ev.contractId);
      this.patientForm.get('name.titleCode').setValue(ev.titleCode)
      this.patientForm.get('maritalStatus').setValue(ev.maritalStatus)
    }

  }
  unKnownFlag: any = 0
  knownFun(check) {
    // tslint:disable-next-line:triple-equals
    if (check == true) {
      this.known = true;
      this.patientForm.get('name.fnameEn').setValue('unknown');
      this.patientForm.get('name.snameEn').setValue('emergency');
      this.patientForm.get('name.tnameEn').setValue('patient');
      this.patientForm.get('name.lnameEn').setValue('');
      this.patientForm.get('name.fnameAr').setValue('مريض');
      this.patientForm.get('name.snameAr').setValue('طوارئ');
      this.patientForm.get('name.tnameAr').setValue('مجهول');
      this.patientForm.get('name.lnameAr').setValue('الهويه');
      this.patientForm.get('identity.identityType').setValue(5);
      this.patientForm.get('name.titleCode').setValue(1);
      this.unKnownFlag = 1
    }
    // tslint:disable-next-line:triple-equals
    if (check == false) {
      this.known = false;
      this.patientForm.get('name.fnameEn').setValue('');
      this.patientForm.get('name.snameEn').setValue('');
      this.patientForm.get('name.tnameEn').setValue('');
      this.patientForm.get('name.lnameEn').setValue('');
      this.patientForm.get('name.fnameAr').setValue('');
      this.patientForm.get('name.snameAr').setValue('');
      this.patientForm.get('name.tnameAr').setValue('');
      this.patientForm.get('name.lnameAr').setValue('');
      this.patientForm.get('identity.identityType').setValue(5);
      this.patientForm.get('name.titleCode').setValue(null);
      this.unKnownFlag = 0
    }
  }


  // new code i.hamed
  empData: PatientVM = <PatientVM>{}
  getPatFromEmp(ev) {
    console.log('this.empData', this.empData);
    if (!this.patientForEdit) {
      if (ev && ev != null && ev['AutoEmited'] == false) {
        console.log(ev.code);
        let searchObj: Employee = <Employee>{};
        searchObj.offset = 0;
        searchObj.pageSize = 10;
        searchObj.fastSearchData = ev.code;
        console.log(searchObj);
        this.resetForm();
        this.getEmpData(searchObj);

      }
    }
  }
  getPatMobile(ev) {
    if (ev && ev != null && ev['AutoEmited'] == false) {
      this.patientForm.get('mobile').setValue(ev.mobile);
    }
  }

  getEmpData(searchObj: Employee) {
    this._patientService.searchEmps(searchObj)
      .subscribe(
        searchResult => {
          if (searchResult.data && searchResult.data.length > 0) {
            this.empData = searchResult.data[0];
            this.patientForm.get('employeeId').setValue(this.empData.code);
            this.empData.code = 0;
          }
        },
        error => console.log(error),
        () => {
          this.empData['ExistEmployeeFlag'] = true
          console.log(this.empData);
          this.setPatientToForm(this.empData);

        });
  }
  //edited by EMAD.AL
  recevTitleCode(titelCode: number) {
    if (titelCode) {
      if (titelCode == 1) {
        this.patientForm.get('gender').setValue(1);
      }
      if (titelCode == 2) {
        this.patientForm.get('gender').setValue(2);
      }
    }
  }
  //////////////////////////////////////////////////////////send registeration Sms /////////////////////////////////////////
  msgTemplateData: any
  //data of sms message
  getMsgTemplate() {
    this.msgTemplate.fieldName = 'registrationPatientSMS'
    this._SmsService.getMsgTemplate(this.msgTemplate)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        res => {
          if (res && res.data) {
            this.msgTemplateData = res.data[0];

          }
        }
      )
  }
  saveMessagesLog() {
    //get template message
    if (this.msgTemplateData) {
      if (this.msgTemplateData.smsTemplate) {
        //create message
        this.replacrDatainSms()
        //meesage data
        this.messagesLog.serial = -1
        this.messagesLog.patCode = this.editPatient['patCode']
        this.messagesLog.message = this.msgTemplateData.smsTemplate
        this.messagesLog.sentDate = new Date()
        this.messagesLog.sender = +JSON.parse(sessionStorage.getItem('currentUser')).userID
        this.messagesLog.mobile = this.patientForm.value.mobile;
        let mArr = [];
        mArr.push(this.messagesLog)
        this._SmsService.ConfirmationRegisterationMsg(mArr)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(res => {
            // if (res && res.returnFlag)
            //   this.goBack();
          })
      }
    }
  }
  replacrDatainSms() {
    // this.msgTemplateData.smsTemplate = this.msgTemplateData.smsTemplate.replace('{{this.doctorName}}', this.doctorName)
    //   .replace('{{this.reservationDate}}', date)
    // console.log(this.msgTemplateData.smsTemplate)
  }
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  goSearchPatient() {
    this.setActiveIndex.emit(8);

  }
}
